<template>
  <div class="card">
    <div class="card-header">
      <h3>Audit Log</h3>
      <small class="form-text text-muted">Immutable — every state-changing action on this wallet, written by #171a's audit service.</small>
    </div>
    <div class="card-body">
      <div v-if="isLoading" class="text-center py-3">
        <span class="spinner-border spinner-border-sm me-2"></span> Loading...
      </div>
      <div v-else-if="rows.length === 0" class="text-muted">No audit activity yet.</div>
      <div v-else class="table-responsive">
        <table class="table table-borderless">
          <thead>
          <tr>
            <th>Date</th>
            <th>Action</th>
            <th>Actor</th>
            <th>Approved By</th>
            <th>Amount</th>
            <th>Reason</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="row in rows" :key="row.id">
            <td>{{ formatDate(row.createdOn) }}</td>
            <td>{{ (row.action || '').replaceAll('_', ' ') }}</td>
            <td class="text-muted small">{{ row.actorType }} {{ row.actorId ? '(' + row.actorId.slice(0, 8) + ')' : '' }}</td>
            <td class="text-muted small">{{ row.approvedBy ? row.approvedBy.slice(0, 8) : '—' }}</td>
            <td v-html="row.amountMinor !== null && row.amountMinor !== undefined ? minorCurrency(row.amountMinor) : '—'"></td>
            <td>{{ row.reason || '' }}</td>
          </tr>
          </tbody>
        </table>
      </div>

      <nav v-if="totalPages > 1" class="d-flex justify-content-between align-items-center mt-2">
        <button class="btn btn-outline-secondary btn-sm" :disabled="page <= 1" @click="changePage(page - 1)">Previous</button>
        <span class="text-muted small">Page {{ page }} of {{ totalPages }} ({{ totalRows }} entries)</span>
        <button class="btn btn-outline-secondary btn-sm" :disabled="!hasNext" @click="changePage(page + 1)">Next</button>
      </nav>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { minorCurrency } from '../utility/DatatableRenderer';

const props = defineProps({
  walletId: { type: String, required: true }
});

const rows = ref([]);
const page = ref(1);
const totalPages = ref(0);
const totalRows = ref(0);
const hasNext = ref(false);
const isLoading = ref(false);

const formatDate = (value) => value ? new Date(value).toLocaleString() : '';

const load = async () => {
  isLoading.value = true;
  try {
    const response = await fetch(`/api/admin/wallets/${props.walletId}/audit-log?page=${page.value}`);
    if (response.ok) {
      const data = await response.json();
      rows.value = data.items || [];
      totalPages.value = data.totalPages || 0;
      totalRows.value = data.totalRows || 0;
      hasNext.value = !!data.hasNext;
    }
  } catch (error) {
    console.error('Error loading wallet audit log:', error);
  } finally {
    isLoading.value = false;
  }
};

const changePage = (next) => {
  if (next < 1) return;
  page.value = next;
  load();
};

onMounted(load);

defineExpose({ load });
</script>
